// extracted by mini-css-extract-plugin
export default {"box":"ActionContent_box__5Dvd9","title":"ActionContent_title__hgYMn"};